import { render, staticRenderFns } from "./AnimatedPhrases.vue?vue&type=template&id=f267347e&scoped=true"
import script from "./AnimatedPhrases.vue?vue&type=script&lang=js"
export * from "./AnimatedPhrases.vue?vue&type=script&lang=js"
import style0 from "./AnimatedPhrases.vue?vue&type=style&index=0&id=f267347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f267347e",
  null
  
)

export default component.exports